import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'
import {useHistory} from 'react-router-dom'

import {Box, Card, Grid, Typography, useTheme} from '@mui/material'
import {getSpacing, PGTypography} from '@progynyglobal/pg-ui-library'

import {ReactComponent as PersonalizeImage} from '@progyny/assets/images/personalize-check.svg'
import MobileStickyActions, {
  MOBILE_STICKY_HEIGHT,
} from '@progyny/components/MobileStickyActions'
import {Navigator} from '@progyny/components/Navigator'
import {useResponsive} from '@progyny/hooks/useResponsive'
import {RouteEnum, useRoutes} from '@progyny/routes'

const PersonalizeJourney: FC = () => {
  const {t} = useTranslation()
  const history = useHistory()
  const {getPath} = useRoutes()
  const theme = useTheme()
  const isMobile = useResponsive('down', 'md')

  return (
    <Grid
      container
      direction={'column'}
      justifyContent={'center'}
      sx={{padding: {xs: 2, md: 8}}}
    >
      <Grid item xs={12} md={9}>
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
          <Card
            sx={{
              padding: {xs: 2, md: 8},
              width: {xs: '100%', md: '700px'},
              borderRadius: {xs: 0, md: 4},
              boxShadow: {xs: 'none', md: 1},
            }}
          >
            <Box
              mb={6}
              display={'flex'}
              justifyContent={'center'}
              pb={{xs: MOBILE_STICKY_HEIGHT, md: 0}}
            >
              <Box
                sx={{
                  background: theme.palette.neutral[50],
                  borderRadius: '100%',
                  height: 100,
                  width: 100,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <PersonalizeImage fontSize={60} />
              </Box>
            </Box>
            <Box mb={4}>
              <PGTypography variant='header' textAlign={'center'}>
                {t(
                  'create_account_personalize_journey_let_s_personalize_your_experience'
                )}
              </PGTypography>
            </Box>
            <Box>
              <Grid container justifyContent={'center'}>
                <Grid item xs={12} sm={11}>
                  <Typography
                    variant={'body1'}
                    textAlign={'center'}
                    lineHeight={1.8}
                  >
                    {t(
                      'create_account_personalize_journey_answer_few_quick_questions_so'
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Box>
      </Grid>
      <MobileStickyActions>
        <Navigator
          label={t('create_account_personalize_journey_let_s_go')}
          showBackButton={false}
          onNextButtonClick={() =>
            history.push(getPath(RouteEnum.SETUP_PROFILE))
          }
          singleCentered
          fullWidth={isMobile}
        />
      </MobileStickyActions>
    </Grid>
  )
}

export default PersonalizeJourney
